/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3, _BioExamResultsEditionFormComponent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from "@ember/object";
import RouterService from "@ember/routing/router-service";
import { service } from "@ember/service";
import { tracked } from "@glimmer/tracking";
import { ForcBaseArgs } from "core/components/forc/abstract/base-component";
import CrudJournalEventBaseComponent from "core/components/forc/abstract/crud-journal-event-based-component";
import { ToastMessage } from "core/components/forc/abstract/journal-event-based-component";
import DraftManager from "core/components/forc/draft-manager";
import BioExamResultsReceivedJournalEvent from "core/models/bio-exam-results-received-journal-event";
import BioExamObservation from "core/models/loinc";
import Patient from "core/models/patient";
import SemeiaSessionService from "core/services/session";
import { BufferedChangeset } from "ember-changeset/types";
import $ from "jquery";
import { ExamsByGroup, getGroupedBioExams } from "../utils/groupedBioExams";
import bioExamResultsFilter from "./bio-exam-results-config-filter";
import styles from "./index.module.css";
let BioExamResultsEditionFormComponent = (_class = (_BioExamResultsEditionFormComponent = class BioExamResultsEditionFormComponent extends CrudJournalEventBaseComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "styles", styles);
    _initializerDefineProperty(this, "router", _descriptor, this);
    _defineProperty(this, "bioExamResults", bioExamResultsFilter(this.patient, this.patient.therapeuticalArea?.defaultBioExams));
    _defineProperty(this, "autoSaveDraft", true);
    _initializerDefineProperty(this, "session", _descriptor2, this);
    _initializerDefineProperty(this, "isInvalid", _descriptor3, this);
    // eslint-disable-next-line parog-web/no-use-of-model-in-crud-forc
    _defineProperty(this, "retrieveJournalEvent", () => this.model);
  }
  get groupedBioExamsObs() {
    const sortedBioExams = this.bioExamResults.map(res => res.bioExamObservation).sort(function (bioA, bioB) {
      return bioA.rank - bioB.rank;
    });
    return getGroupedBioExams(sortedBioExams);
  }
  get toastMessage() {
    return this.session.patient ? {
      message: "Vos résultats ont été envoyés.",
      title: "Résultats de biologie"
    } : super.toastMessage;
  }
  get isDirty() {
    if (this.changeset.isInvalid) return false;
    return super.isDirty;
  }
  get model() {
    // eslint-disable-next-line parog-web/no-use-of-model-in-crud-forc
    return this.args.model;
  }
  get changeset() {
    this.draft = new DraftManager(this);
    return this.args.changeset;
  }
  get patient() {
    return this.args.patient;
  }
  async save() {
    this.changeset.set("normalized", true);
    await super.save();
  }
  onFileUploadClicked() {
    if (this.session.medic) {
      $(".sidebar").sidebar("show");
      this.router.transitionTo(this.router.currentRouteName, {
        queryParams: {
          tab: "upload-document"
        }
      });
    } else {
      this.router.transitionTo(`patient-web.protected.feature.component`, "document", "edition-form", {
        queryParams: {
          callbackUrl: "/patient-web/bio-results/edition"
        }
      });
    }
  }
}, _defineProperty(_BioExamResultsEditionFormComponent, "fullComponentId", "bio-exam-results/edition-form"), _defineProperty(_BioExamResultsEditionFormComponent, "forcDisplayName", "Résultats biologiques"), _defineProperty(_BioExamResultsEditionFormComponent, "journalEventClass", BioExamResultsReceivedJournalEvent), _BioExamResultsEditionFormComponent), _descriptor = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "isInvalid", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "onFileUploadClicked", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onFileUploadClicked"), _class.prototype), _class);
export { BioExamResultsEditionFormComponent as default };